var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath306(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.149,
    height: 24.149,
    viewBox: "0 0 24.149 24.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M12.074,0A12.074,12.074,0,1,0,24.149,12.074,12.11,12.11,0,0,0,12.074,0ZM7.547,8.05A1.509,1.509,0,1,1,6.037,9.559,1.548,1.548,0,0,1,7.547,8.05ZM17.81,16.8a7.977,7.977,0,0,1-5.735,2.314A7.977,7.977,0,0,1,6.339,16.8a1,1,0,1,1,1.409-1.409,6.169,6.169,0,0,0,4.327,1.711A6.169,6.169,0,0,0,16.4,15.395,1,1,0,0,1,17.81,16.8ZM16.6,11.068a1.509,1.509,0,1,1,1.509-1.509A1.548,1.548,0,0,1,16.6,11.068Z",
    fill: "#cecfd0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath306);
export default __webpack_public_path__ + "static/media/Path 306.b3068b073fb6923d173cac180c07bce6.svg";
export { ForwardRef as ReactComponent };